
  $(document).ready(function(){
  $(document).on('click', '.custom_faq_section .main_faq', function () {
  var content = $(this).find('.content');
  var plus = $(this).find('.plus');
  var minus = $(this).find('.minus');

  if (content.is(':visible')) {
    content.slideUp();
    plus.show();
    minus.hide();
  } else {
    content.slideDown();
    plus.hide();
    minus.show();
  }
});
$(document).on('mouseenter', '.custom_product_list_slider .data_value', function () {
  var image = $(this).attr('data-img');
  console.log("Hovered image:", image);
  $(this).closest('.custom_product').find('.first_image').attr('src', image);
});




    
});


  $(document).ready(function () {
  $('.custom_product').each(function () {
    var $product = $(this);
    var color = '';
    var size = '';

    var colorOptions = $product.find('.data_value.color_value');
    var sizeOptions = $product.find('.main_value_wrp .size_val');

    // Default color
    if (colorOptions.length > 0) {
      var firstColorOption = colorOptions.first();
      firstColorOption.addClass('active');
      color = firstColorOption.text().trim();
      console.log('Default color selected:', color);
    }

    // Default size
    var activeSize = sizeOptions.filter('.active');
    if (activeSize.length === 0 && sizeOptions.length > 0) {
      activeSize = sizeOptions.first().addClass('active');
    }
    size = activeSize.text().trim();

    matchoption($product, color, size);
  });
});

// Size selection
$(document).on('click', '.main_value_wrp .size_val', function () {
  var $product = $(this).closest('.custom_product');
  $product.find('.main_value_wrp .size_val').removeClass('active');
  $(this).addClass('active');
  var size = $(this).text().trim();
  var color = $product.find('.data_value.color_value.active').text().trim() || '';
  matchoption($product, color, size);
});

// Color selection
$(document).on('click', '.custom_product .data_value.color_value', function () {
  var $product = $(this).closest('.custom_product');
  $product.find('.data_value.color_value').removeClass('active');
  $(this).addClass('active');
  var color = $(this).text().trim();
  var size = $product.find('.main_value_wrp .size_val.active').text().trim() || '';
  matchoption($product, color, size);
});

// Match variant and update form
function matchoption($product, color, size) {
  var combine_option = '';
  var hasColor = $product.find('.data_value.color_value').length > 0;

  if (hasColor) {
    if (!color || !size) return;
    combine_option = color + ' / ' + size;
  } else {
    if (!size) return;
    combine_option = size;
  }

  console.log('Trying to match:', combine_option);

  $product.find('.variant_custom_ids option').each(function () {
    var title = $(this).attr('var_title') || $(this).data('title');
    if (title && title.trim() === combine_option) {
      $(this).prop('selected', true);
      var variantId = $(this).attr('var_id') || $(this).data('id');
      console.log('Matched Variant:', variantId);

    
      $product.find('.var_value').val(variantId);

     
      $product.find('.new_cart_btn')
        .attr('varr_id', variantId)
        .attr('var_size', size);

      return false; // stop loop on match
    }
  });
}


  
$(document).on('click', '.custom_add_to_cart', function() {
  var var_id = $(this).closest('.custom_product').find('.var_value').val();
  console.log("Variant ID:", var_id);

  // Basic check
  if (!var_id) {
    alert("Variant ID not found");
    return;
  }

  // AJAX add to cart
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: var_id
    },
    dataType: 'json',
    success: function(response) {
      console.log("Added to cart:", response);
      // Redirect to cart page
      window.location.href = '/cart';
    },
    error: function(xhr, status, error) {
      console.error("Add to cart failed:", error);
      alert("Failed to add product to cart.");
    }
  });
});


